import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'item' ]

  toggle(event) {
    let currentCheckbox = event.target
    if (currentCheckbox.checked) {
      for (let checkbox of this.targets.findAll('item')) {
        if (checkbox !== currentCheckbox) {
          checkbox.disabled = true;
        }
      }
    } else {
      for (let checkbox of this.targets.findAll('item')) {
        checkbox.disabled = false;
      }
    }
  }
}